// extracted by mini-css-extract-plugin
export default {"paypalButtonContainer":"_2YrK6","paypalButton":"_3K1w_","hidden":"_3q4tS","loader":"_2t38Z"};